<template>
  <div class="top-nav-dock" :class="{'active':showNavDrawer}" @mouseenter="showNavDrawer=true" @click="showNavDrawer=!showNavDrawer"><span></span><span></span><span></span></div>
  <div class="topbar-drawer-mask" v-if="showNavDrawer" @click="showNavDrawer=false"></div>
  <div class="topbar-drawer" :style="{'left':showNavDrawer?'0':'-500%'}">
    <div class="close-icon" @click="showNavDrawer=false"><CloseCircleOutlined /></div>
    <div class="topbar-drawer-content">
      <div class="topbar-drawer-input">
        <a-input v-model="searchText" :allowClear="true" placeholder="输入菜单关键字快捷搜索">
          <template #suffix>
            <SearchOutlined style="font-size:20px" />
          </template>
        </a-input>    
      </div>

      <div class="topbar-drawer-grouplist">
        <div class="topbar-drawer-list" v-for="(navs,idx) in NavDatas" :key="idx">
          <div class="topbar-drawer-items">
            <h4>{{navs?.title}}</h4>
            <div class="nav-items-group">
              <div class="nav-items" v-for="(item,i) in navs.children" :key="i">
                <!-- <a href="javascript:;" :class="{'active': activeMenu.endsWith('/'+item.key)}" :data-index="item.key" @click="goRouter(item.key)">{{item?.title}}</a> -->
                <a @click="goRouter(item)" :class="{'active': activeMenu.endsWith(item.key)}">{{item?.title}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { PoweroffOutlined, DoubleLeftOutlined, DoubleRightOutlined, SearchOutlined, CloseCircleOutlined } from '@ant-design/icons-vue';
import {ref, computed, h} from 'vue'
import {useRoute, useRouter} from 'vue-router'

import NavDatas from './navs'

const route = useRoute();
const router = useRouter();
const searchText = ref('')
const showNavDrawer = ref(false)

const activeMenu = computed(() => {
  const { meta, path } = route;
  // if set path, the sidebar will highlight the path you set
  // if (meta.activeMenu) {
  //   return meta.activeMenu;
  // }
  return path;
})

function goRouter(item) {
  router.push({path:item.key})
  showNavDrawer.value = false
}

</script>
<style lang="scss">
.topbar-drawer-input {
  padding: 0 40px 10px 20px;
  .ant-input-affix-wrapper {
    height: 40px;
    padding: 0 40px 0 20px;
    border-radius: 0;
    font-size: 14px;
    border: unset;
    border-bottom: 1px solid #ddd;
    box-shadow: unset;
    padding: 0 20px;
    font-weight: 400;
  }
}
</style>
<style lang='scss' scoped>
.top-nav-dock {
  width: 50px;
  height: 50px;
  // background-color: #698334;
  // margin-right: 10px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  &>span {
    display: block;
    position: absolute;
    left: 15px;
    background-color: rgb(255, 255, 255);
    width: 20px;
    height: 2px;
    transition: 0.3s ease-out;
    &:first-child {
      top: 17px;
      transform: rotate(0deg);
      transform-origin: left center;
    }
    &:nth-child(2) {
      top: 24px;
    }
    &:nth-child(3) {
      top: 31px;
      transform: rotate(0deg);
      transform-origin: left center;
    }
  }
  
}
.top-nav-dock.active {
  text-decoration: none;
  &>span {
    &:first-child {
      transform: rotate(45deg);
    }
    &:nth-child(2) {
      opacity: 0;
    }
    &:nth-child(3) {
      transform: rotate(-45deg);
    }
  }
}
.topbar-drawer-mask {
  position: fixed;
  top: 54px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.3);
  z-index: 100;
}
.topbar-drawer {
  position: fixed;
  top: 54px;
  bottom: 0px;
  font-size: 12px;
  will-change: left;
  z-index: 1003;
  width: 750px;
  background-color: #fff;
  left: 0px;
  transform: translateX(0px);
  overflow: hidden;
  transition: transform 200ms linear, left 200ms;
  box-shadow: 1px 0 2px 0 rgba(0, 0, 0, 0.16);
  .close-icon {
    position: absolute;
    top: 0px;
    right: 20px;
    font-size: 24px;
    z-index: 1;
    color: #999;
    cursor: pointer;
    &:hover {
      opacity: .8;
    }
  }
  .topbar-drawer-content {
    height: 100%;
    overflow: hidden;
    padding-top: 12px;
    .topbar-drawer-group {
      // margin-bottom: 16px;
      width: 100%;
      break-inside: avoid;
      &>h4 {
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0px 0px 0px 8px;
        margin: 0px;
        height: 32px;
        line-height: 32px;
        font-weight: 600;
        font-size: 12px;
      }
      &>h3 {
        position: relative;
        padding: 0px;
        margin: 0px 0px 0px 4px;
        height: 32px;
        font-size: 12px;
        color: #666;
        font-weight: 600;
        line-height: 32px;
        display: inline-flex;
        width: 100%;
        -webkit-box-align: center;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &::before {
          content: '';
          display: flex;
          width: 20px;
          height: 20px;
          background: url('@/assets/images/nav-icon.png') no-repeat center;
          background-size: 100% auto;
          margin-right: 2px;
        }
        &::after {
          content: "";
          flex: 1 1 0%;
          border-right: none;
          border-bottom: none;
          border-left: none;
          border-image: initial;
          margin-left: 0.5em;
          border-top: 1px solid #ebebeb;
        }
      }
    }
    .topbar-drawer-grouplist {
      // columns: 200px 3;
      // column-gap: 12px;
      overflow: hidden auto;
      padding: 0 20px 20px;
      height: calc( 100% - 80px );

    }
    .nav-items-group {
      columns: 200px 3;
      column-gap: 12px;

    }
    .topbar-drawer-list {
      // columns: 200px 3;
      // column-gap: 12px;
      break-inside: avoid;
      .topbar-drawer-items {
        // break-inside: avoid;
        &>h4 {
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0px 0px 0px 8px;
          margin: 0px;
          height: 32px;
          line-height: 32px;
          font-weight: 600;
          font-size: 16px;
          display: flex;
          align-items: center;
          position: relative;
          &::before {
            content: '';
            display: flex;
            width: 3px;
            height: 10px;
            // background-color: #698334;
            background: linear-gradient(93.04deg, #4797FE 5.38%, #65BBF7 99.08%);

            // transform: rotate(45deg);
            border-radius: 2px;
            margin-right: 4px;
          }
        }
        .nav-items {
          position: relative;
          transition: 300ms ease-in-out;
          cursor: pointer;
          break-inside: avoid;
          display: flex;
          align-items: center;
          width: 100%;
          max-width: 100%;
          color: #000;
          line-height: 36px;
          // padding-left: 6px;
          &:hover {
            background: rgba(0, 46, 70, 0.04314)
          }
          .platforms {
            display: flex;
            align-items: center;
            &>a {
              &:hover {
                color: #698334;
                text-decoration: underline;
              }
            }
          }
          a {
            outline: none;
            background: none;
            transition: 0.3s ease-out;
            display: block;
            border-width: 1px;
            border-style: solid;
            border-image: initial;
            border-radius: 2px;
            width: 100%;
            max-width: 100%;
            cursor: pointer;
            vertical-align: middle;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 32px;
            line-height: 30px;
            font-size: 13px;
            background-color: transparent;
            border-color: transparent;
            padding: 0px 16px;
            font-weight: 400;
            color: #666;
          }
          a:link, a:visited, a:hover, a:active {
            text-decoration: none;
          }
          a:visited {
            color: #024b6a;
          }
          a.active {
            background-color: #9EC5FF;
            // background: linear-gradient(269.8deg, rgba(239, 242, 252, 0.0001) 84.54%, #EFF2FC -3.41%);
            // background: linear-gradient(65.38deg, #5678FF 7.2%, #75BDFF 90.18%);

            font-weight: bold;
            color: #000;
          }
          span.active {
            // background-color: #698334;
            // background-color: #f0f2ea;
            font-weight: bold;
            // color: #fff;
            border-radius: 2px;
            padding: 0 8px;
            color: #698334;
          }
        }
      }
    }
  }
}
@media ( max-width : 768px) {
  .topbar-drawer {
    width: 100%;
  }
}
</style>